module.exports = __webpack_public_path__ + "img/map_9.d292bb0a.png";